<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      :expand-config="{ reserve: true }"
      resizable
      border
      show-footer
      :footer-method="() => footerData"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <ExpandGoodsTable class="m-2" :orderBatchCode="row.orderBatchCode" />
      </template>

      <template v-slot:shippingMarkContext="{ row }">
        <div class="shippingMark" v-if="row.shippingMarkType">
          <span class="shippingMark_text">
            {{ row.shippingMarkText }}
          </span>
          <span class="shippingMark_image">
            <el-image
              style="width: 80px; height: 80px"
              fit="contain"
              :src="
                row.shippingMarkImageUrl
                  ? row.shippingMarkImageUrl
                  : '/image/static/img/nopic.jpg'
              "
              :preview-src-list="[
                row.shippingMarkImageUrl
                  ? row.shippingMarkImageUrl
                  : '/image/static/img/nopic.jpg',
              ]"
            >
            </el-image>
          </span>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  params: row,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabled && !row.shipmentCode"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', { type: 'edit', params: row })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabled && !row.shipmentCode"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_copy') || '复制'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="
                $emit('openEditFormDialog', { type: 'copy', params: row })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import ExpandGoodsTable from '../expand-goods-table'
import { add } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight],
  components: { ExpandGoodsTable },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns.map(
        (t) => totalColumnValues[t.field] || ''
      )
      result[0] = '合计'

      return [result]
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del({ orderBatchCode }) {
      this.$emit('batchDel', [orderBatchCode])
    },
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }
      if (data.length > 20) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_max_select_rows') ||
            '最多可选择20行！',
          type: 'warning',
        })
        return
      }
      if (type === 'code') {
        return data.map((row) => row.orderBatchCode)
      }
      return data
    },
  },
}
</script>
<style lang="scss" scoped>
.shippingMark {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  .shippingMark_text {
    margin-right: 10px;
    font-size: 30px;
  }
}
</style>
